import api from "./api";
import {id} from "date-fns/locale";

const FeatureAppAPI = {
    getAll: () => api.get("/feature-apps/all"),
    getById: (id) => api.get(`/feature-apps/details/${id}`),
    insert: (params) => api.post(`/feature-apps/insert`, params),
    update: (params) => api.post(`/feature-apps/update`, params),
    delete: (id, fileName) => api.post(`/feature-apps/delete/${id}/${fileName}`),
};

export default FeatureAppAPI;